import validate from '@rootstrap/validate';
import { useCallback } from 'react';

validate.validators.presence.options = { allowEmpty: false };

export default (constraints, options = { fullMessages: false }) =>
  useCallback(values => validate(values, constraints, options), [constraints, options]);
